const contactSupportES = {
	title: "Contacto y Soporte",
	support: {
		title: "¿Necesitas Ayuda?",
		text: "Si tienes preguntas, encuentras un problema o necesitas asistencia con ReservaSinFila, estamos aquí para ayudarte.",
	},
	email: {
		title: "Correo de Soporte",
		text: "Puedes comunicarte con nosotros en cualquier momento al correo:",
	},
	response: {
		title: "Tiempo de Respuesta",
		text: "Respondemos dentro de 24 horas, normalmente mucho más rápido en días laborales.",
	},
};

export default contactSupportES;

